import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertCircleIcon, LogOutIcon } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { useEspace } from '../../contexts/EspaceContext';
export function AccountManagement() {
  const [confirming, setConfirming] = useState(false);
  const {
    logout
  } = useAuth();
  const {
    exitEspace
  } = useEspace();
  const navigate = useNavigate();
  return <section aria-labelledby="gestion-compte-titre" className="mt-10 border-t border-slate-200 pt-8" data-id="element-2679" data-mp="3ax1fiik6mx7o">
      <h2 id="gestion-compte-titre" className="text-sm font-bold uppercase tracking-wider text-slate-500" data-id="element-2680" data-mp="3fuujd4y0jf4s">
        Gestion du compte
      </h2>

      <button type="button" onClick={() => {
      logout();
      exitEspace();
      navigate('/');
    }} className="mt-3 inline-flex items-center gap-2 rounded-full border border-slate-200 px-5 py-2.5 text-sm font-bold text-ville-navy transition-colors duration-150 ease-ville hover:border-ville-indigo hover:bg-ville-indigo-soft hover:text-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-2681" data-mp="3pk4dsrgbx9w2">
        <LogOutIcon className="h-4 w-4" aria-hidden="true" data-id="element-2682" data-mp="176553g14ce5r" />
        Se déconnecter
      </button>

      {!confirming ? <div className="mt-6 flex flex-wrap items-center gap-x-6 gap-y-2" data-id="element-2683" data-mp="xe97e62y2q22">
          <button type="button" onClick={() => setConfirming(true)} className="text-sm font-semibold text-slate-500 underline underline-offset-4 transition-colors duration-150 ease-ville hover:text-red-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-2684" data-mp="xc50rgdnvcy3">
            Supprimer mon compte
          </button>
          <p className="text-sm text-slate-500" data-id="element-2685" data-mp="egy5edpxhiix">La suppression est définitive et retire l’accès à vos services.</p>
        </div> : <div className="mt-3 max-w-2xl rounded-2xl border border-red-200 bg-red-50 p-5" data-id="element-2686" data-mp="28teavcawgsmq">
          <div className="flex items-start gap-3" data-id="element-2687" data-mp="73yv5dq76bo6">
            <AlertCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-600" aria-hidden="true" data-id="element-2688" data-mp="72e3pwz6j8uj" />
            <div data-id="element-2689" data-mp="bw9xen8eu9jw">
              <p className="font-bold text-ville-navy" data-id="element-2690" data-mp="bws2m9d1vy3y">Supprimer définitivement votre compte ?</p>
              <p className="mt-1 text-sm text-slate-600" data-id="element-2691" data-mp="3t93yexmowyz4">
                Vos adresses, préférences et consentements seront effacés. Cette action est irréversible.
              </p>
            </div>
          </div>
          <div className="mt-4 flex flex-wrap gap-3" data-id="element-2692" data-mp="psngu1wi8l10">
            <button type="button" onClick={() => setConfirming(false)} className="rounded-full border border-slate-300 bg-white px-5 py-2.5 text-sm font-bold text-ville-navy transition-colors duration-150 ease-ville hover:border-ville-indigo hover:text-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-2693" data-mp="us8feb7rird7">
              Annuler
            </button>
            <button type="button" className="rounded-full bg-red-600 px-5 py-2.5 text-sm font-bold text-white transition-colors duration-150 ease-ville hover:bg-red-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-600 focus-visible:ring-offset-2" data-id="element-2694" data-mp="35j9mqje3xggg">
              Confirmer la suppression
            </button>
          </div>
        </div>}
    </section>;
}